import api from './api';
import { fleetImportApi } from './fleetImportApi';

/**
 * Import de la liste des camions d'un lot (Excel, CSV ou PDF), lot 057.
 *
 * Seuls le dépôt et la lecture du travail en cours sont propres au lot
 * (`backend/app/api/v1/lots.py`). Le reste du parcours — suivi, correspondance
 * des colonnes, corrections, confirmation, annulation, rapport — passe par les
 * routes de l'import de flotte (`/fleet-import/jobs/{id}…`), que le serveur
 * ouvre à qui peut écrire les lots pour ces travaux. Rien n'est calculé ici.
 */

// Le serveur répond `{ success, data }` : `data` vaut `null` quand il n'y a rien (aucun import en
// cours). Ce `null` est la réponse, il ne faut pas retomber sur l'enveloppe entière.
const unwrap = (response) => {
  const corps = response?.data;
  return corps && typeof corps === 'object' && !Array.isArray(corps) && 'data' in corps ? corps.data : corps;
};

export const EXTENSIONS_LISTE = '.xlsx,.csv,.pdf';
/** États où le serveur travaille : on relit le travail tant qu'ils durent. */
export const ETATS_EN_COURS = ['queued', 'analyzing', 'confirmed', 'importing'];
/** États où un import occupe encore le lot (brouillon compris). */
export const ETATS_OUVERTS = [...ETATS_EN_COURS, 'draft'];

export const lotImportApi = {
  /** Le travail d'import de ce lot (en cours, ou le dernier terminé), ou `null`. */
  async current(lotId) {
    return unwrap(await api.get(`/lots/${lotId}/import/current`, { skipToast: true })) || null;
  },

  /** Dépose la liste ; l'analyse se poursuit en arrière-plan. */
  async upload(lotId, file) {
    const formulaire = new FormData();
    formulaire.append('file', file);
    return unwrap(
      await api.post(`/lots/${lotId}/import`, formulaire, {
        headers: { 'Content-Type': 'multipart/form-data' },
        timeout: 120000,
      }),
    );
  },

  get: (jobId) => fleetImportApi.get(jobId),
  updateMapping: (jobId, entries) => fleetImportApi.updateMapping(jobId, entries),
  confirm: (jobId, draftVersion) => fleetImportApi.confirm(jobId, draftVersion),
  cancel: (jobId) => fleetImportApi.cancel(jobId),
};

export default lotImportApi;
